import { PersonDetails, Request } from "../../../models/Request";

/**
 * Trims whitespace from other parent's first and last names
 * @param request The request containing other parent details
 * @returns A new request object with trimmed other parent names
 */
export const trimOtherParentNames = (request: Request): Request => {
  return {
    ...request,
    otherParentDetails: {
      ...(request.otherParentDetails as PersonDetails),
      firstName: request.otherParentDetails?.firstName?.trim() ?? "",
      lastName: request.otherParentDetails?.lastName?.trim() ?? "",
      person: {
        ...request.otherParentDetails?.person,
        firstName: request.otherParentDetails?.person?.firstName?.trim() ?? "",
        lastName: request.otherParentDetails?.person?.lastName?.trim() ?? "",
        alternativeDocumentNumber:
          request.otherParentDetails?.person?.alternativeDocumentNumber ?? null,
        alternativeDocumentTypeId:
          request.otherParentDetails?.person?.alternativeDocumentTypeId ?? null,
        alternativeDocumentReasonId:
          request.otherParentDetails?.person?.alternativeDocumentReasonId ??
          null,
      },
    },
  };
};
